module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/stepper_up_purple@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/stepper_up_purple@1x.png
// module id = 668
// module chunks = 0